const initEkHeaderScroll = (scope: ParentNode = document) => {
  const wrapper = (scope === document
    ? document.querySelector(".ek-megamenuHolder")
    : scope.querySelector(".ek-megamenuHolder") ?? scope.closest?.(".ek-megamenuHolder")
  ) as HTMLElement | null;

  if (!wrapper) return;
  if (wrapper.dataset.ekHeaderScrollInit === "true") return;
  wrapper.dataset.ekHeaderScrollInit = "true";

  const topBar = wrapper.querySelector("[data-ek-header-bar]") as HTMLElement | null;
  if (!topBar) return;

  // Read background color config for theme-color sync
  const configEl = topBar.querySelector("[data-ek-header-config]");
  const config = configEl ? JSON.parse(configEl.textContent || "{}") : {};
  const pageBackgroundColor: string = config.backgroundColor || "";

  // Product page buy-button guard zone
  const buyButton = document.querySelector(".button-addtocart") as HTMLElement | null;
  const topAreaWithoutStickyHeader = buyButton ? buyButton.offsetTop - 100 : 0;

  let lastScrollTop = 0;
  let furthestScrollTop = 0;
  let topBarState: "top" | "hidden" | "sticky" = "top";
  let isAccordionScrolling = false;

  const pixelThreshold = 50;

  const setWrapperHeight = () => {
    wrapper.style.height = topBar.offsetHeight + "px";
    window.navBarHeight = topBar.offsetHeight;
  };

  const updateThemeColor = (color?: string) => {
    const fallback = pageBackgroundColor || "#FEFEFE";
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute("content", color || fallback);
  };

  const setTopBarState = (targetState: "top" | "hidden" | "sticky", animated: boolean) => {
    if (topBarState === targetState) return;

    if (animated) {
      topBar.classList.add("transition-all", "ease-in-out", "duration-500");
    } else {
      topBar.classList.remove("transition-all", "ease-in-out", "duration-500");
    }

    topBar.classList.toggle("top-bar-is-sticky", targetState !== "top");

    switch (targetState) {
      case "hidden":
        topBarState = "hidden";
        topBar.style.transform = "translateY(-100%)";
        topBar.classList.remove("shadow-xl");
        topBar.classList.add("fixed", "bg-white");
        updateThemeColor(pageBackgroundColor || "#FEFEFE");
        break;

      case "sticky":
        topBarState = "sticky";
        topBar.classList.add("shadow-xl");
        topBar.style.transform = "translateY(0px)";
        updateThemeColor("#FEFEFE");
        break;

      default:
        // top
        topBarState = "top";
        topBar.classList.remove("shadow-xl", "fixed", "bg-white");
        topBar.style.transform = "translateY(0)";
        updateThemeColor();
        break;
    }
  };

  const handleScroll = () => {
    if (isAccordionScrolling) return;

    const scrollTop = window.scrollY;
    const scrollDistance = scrollTop - lastScrollTop;

    if (scrollDistance > 0) {
      // Scrolling down
      if (scrollTop > topBar.offsetHeight + pixelThreshold) {
        const shouldAnimate = topBarState === "sticky";
        setTopBarState("hidden", shouldAnimate);
      }
    } else {
      // Scrolling up
      if (scrollDistance < -350) {
        // Fast scroll (tap status bar)
        setTopBarState("top", false);
        furthestScrollTop = 0;
      } else {
        if (scrollTop <= 0) {
          // At top
          const shouldAnimate = topBarState === "hidden";
          setTopBarState("top", shouldAnimate);
          furthestScrollTop = 0;
        } else {
          // Don't show sticky menu above the cart on product pages
          if (topBarState === "hidden" && scrollTop < topAreaWithoutStickyHeader) {
            return;
          }
          // Don't show until scroll threshold is reached (accumulates across frames)
          if (Math.abs(scrollDistance) < pixelThreshold) {
            return;
          }
          // Show sticky
          if (topBarState === "hidden") {
            setTopBarState("sticky", true);
          }
        }
      }
    }

    lastScrollTop = scrollTop;
    if (scrollTop > furthestScrollTop) furthestScrollTop = scrollTop;
  };

  // Set initial wrapper height
  setWrapperHeight();

  // Use AbortController for clean re-init on section load
  const controller = new AbortController();
  (wrapper as any).__ekHeaderScrollAbort = controller;

  window.addEventListener("scroll", handleScroll, { signal: controller.signal });
  window.addEventListener("resize", setWrapperHeight, { signal: controller.signal });

  document.addEventListener("accordionScrollStart", () => {
    isAccordionScrolling = true;
  }, { signal: controller.signal });
  document.addEventListener("accordionScrollEnd", () => {
    isAccordionScrolling = false;
  }, { signal: controller.signal });

  // Initial state
  if (window.scrollY > 0) {
    setTopBarState("sticky", false);
  } else {
    setTopBarState("top", false);
  }
};

export { initEkHeaderScroll };
